import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=5dbba6f0"
import script from "./snackbar.vue?vue&type=script&lang=js"
export * from "./snackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports